import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export { BACKEND_URL };

export const api = axios.create({ baseURL: API });

// Tokens are kept in localStorage for MVP. For higher security we could move to
// in-memory only with silent refresh via cookie, but the K8s ingress sets
// Access-Control-Allow-Origin: * which forbids credentialed cookies. This is
// the pragmatic compromise for now.
const ACCESS_KEY = "cf_access_token";
const REFRESH_KEY = "cf_refresh_token";

export const tokenStore = {
  get access() { return localStorage.getItem(ACCESS_KEY); },
  get refresh() { return localStorage.getItem(REFRESH_KEY); },
  set(access, refresh) {
    if (access) localStorage.setItem(ACCESS_KEY, access);
    else localStorage.removeItem(ACCESS_KEY);
    if (refresh) localStorage.setItem(REFRESH_KEY, refresh);
    else localStorage.removeItem(REFRESH_KEY);
  },
};

api.interceptors.request.use((config) => {
  const token = tokenStore.access;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatError(d) {
  if (!d) return "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return d?.msg ? d.msg : String(d);
}

/**
 * Polls /api/video/job/{jobId} until status is "done" or "failed".
 * onProgress(seconds_elapsed) called every poll. Max wait 10 min.
 * Returns the final job object. Throws on "failed" or timeout.
 */
export async function pollVideoJob(jobId, { onProgress, intervalMs = 3000, maxWaitMs = 600000 } = {}) {
  const start = Date.now();
  while (true) {
    const { data } = await api.get(`/video/job/${jobId}`);
    if (data.status === "done") return data;
    if (data.status === "failed") {
      const err = new Error(data.error || "Video generation failed");
      err.job = data;
      throw err;
    }
    if (onProgress) onProgress(Math.round((Date.now() - start) / 1000));
    if (Date.now() - start > maxWaitMs) {
      throw new Error("Video generation timed out. Check the Library tab shortly — it may still complete.");
    }
    await new Promise((r) => setTimeout(r, intervalMs));
  }
}
